<template>
  <v-container v-if="viewState.auteurDsply == true">
    <v-row>
      <v-col>
        <v-card dark class="pa-5">
          <v-card-title> 
            <h1 style="color: AntiqueWhite; width: 100%">
              Paroles de l'Auteur
            </h1>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    viewState: {
      get() {
        return this.$store.getters["pigments/viewState"];
      },
      set(newState) {
        return this.$store.commit("pigments/changeDsplyState", newState);
      },
    },
  },
};
</script>

<style scoped>
.integrated-video {
  position:relative;
  padding-bottom:56.25%;
  height:0;
  border: 1px solid grey;
  margin-bottom: 50px;
  overflow:hidden;
}
.media {
  width: 600px;
  margin: 0 auto;
  border-bottom: 1px dashed white;
  padding-bottom: 35px;
  margin-bottom: 35px;;
  padding-top: 35px;
}
</style>